<template>
  <!-- <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1"> -->
  <div style="padding: 0; margin: auto; border-radius: 5px; background: white">
    <v-card
      tile
      flat
      style="
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: 0px;
        background: white;
        z-index: 5;
      "
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
        "
      >
        <v-toolbar-title class="overline">
          <p :style="`font-size:${wWidth > 780 ? '20px' : '3vw'}; margin: 0;`">
            Formulir Registrasi Vendor
          </p>
        </v-toolbar-title>
      </div>
      <div>
        <v-btn
          type="button"
          rounded
          outlined
          elevation="0"
          color="primary"
          class="white--text font-weight-bold ma-2"
          style="font-size: 12px"
          small
          @click="closeForm"
        >
          <v-icon small>mdi-chevron-left</v-icon>
          Batal
        </v-btn>
      </div>
    </v-card>
    <div>
      <v-stepper class="elevation-0" v-model="stepperElement" vertical>
        <v-stepper-step :complete="stepperElement > 1" step="1">
          Informasi Umum Vendor
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-form
            ref="stepOneForm"
            @submit.prevent="nextStep(1)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <!-- <v-col cols="12" md="9" style="padding: 0"></v-col> -->
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Nama Perusahaan *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.company_name"
                        :rules="rules.companyNameRules"
                        name="company_name"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="8" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Jenis Usaha *
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                    >
                      <v-radio-group
                        @keydown.enter.prevent
                        v-model="form.company_type"
                        :rules="rules.companyTypeRules"
                        style="
                          width: 100%;
                          height: 45px;
                          position: relative;
                          top: -10px;
                        "
                      >
                        <div
                          class="d-flex justify-content-around align-content-between"
                        >
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="1"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">UD</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="2"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">CV</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="3"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">PT</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="4"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">
                              Lain - lain
                            </p>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Tahun Berdiri
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        type="number"
                        v-model="form.year_founded"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Alamat Kantor *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-textarea
                        @keydown.enter.prevent
                        dense
                        auto-grow
                        rows="1"
                        outlined
                        v-model="form.company_address"
                        :rules="rules.addressRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Provinsi *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.province"
                        :items="dropdown.province"
                        :rules="rules.provinceRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kota *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.city"
                        :items="dropdown.city"
                        :rules="rules.cityRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kode Pos *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.post_code"
                        :rules="rules.postCodeRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="6" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Lat
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.lat"
                        :rules="rules.latRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="6" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        lng
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.lng"
                        :rules="rules.lngRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        No. Telepon *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        type="number"
                        v-model="form.phone_number"
                        :rules="rules.phoneRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Email *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.email"
                        :rules="rules.emailRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Website (jika ada)
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        v-model="form.website"
                        :rules="rules.websiteRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>

                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Skala Perusahaan *
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      style="
                        padding: 0;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 0;
                      "
                    >
                      <v-radio-group
                        @keydown.enter.prevent
                        v-model="form.company_scale"
                        :rules="rules.companyScaleRules"
                        style="
                          width: 100%;
                          height: 45px;
                          position: relative;
                          top: -10px;
                        "
                      >
                        <div
                          class="d-flex justify-content-around align-content-between"
                        >
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="1"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Kecil</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="2"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Menengah</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="3"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">Besar</p>
                          </div>
                          <div
                            style="
                              padding: 0;
                              justify-content: flex-start;
                              align-items: center;
                              display: flex;
                            "
                          >
                            <v-radio
                              :value="4"
                              style="margin: 0; height: 25px; padding: 0"
                            ></v-radio>
                            <p style="margin: 0; font-size: 12px">
                              Lain - lain
                            </p>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </div>
                </v-col>
                <!--  -->
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Klasifikasi *
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.classification"
                        :rules="rules.classificationRules"
                        :items="dropdown.classification"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <v-col
                  v-if="
                    form.classification != null &&
                    form.classification.sub_classification != null &&
                    form.classification.sub_classification.length > 0
                  "
                  cols="12"
                  md="6"
                  style="padding: 0"
                >
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Sub-Klasifikasi
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-autocomplete
                        @keydown.enter.prevent
                        v-model="form.sub_classification"
                        :items="dropdown.subClassification"
                        :rules="rules.subClassificationRules"
                        style="margin: 0"
                        item-text="name"
                        item-value="id"
                        return-object
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                    </v-col>
                  </div>
                </v-col>
                <!-- Contact Person -->
                <v-col cols="12" style="padding: 10px">
                  <v-row
                    no-gutters
                    style="
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 5px;
                      padding: 10px;
                    "
                  >
                    <v-col cols="12" md="12" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nama Kontak Person *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            outlined
                            :rules="rules.vendorNameRules"
                            v-model="form.vendor_cp_name"
                            autocomplete="on"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Jabatan Kontak Person
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            outlined
                            v-model="form.vendor_cp_position"
                            autocomplete="on"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 0">
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Nomor Kontak Person *
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            outlined
                            type="number"
                            :rules="rules.vendorPhoneRules"
                            v-model="form.vendor_cp_phone"
                            autocomplete="on"
                          />
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                      style="padding: 10px"
                      class="d-flex justify-center align-center"
                    >
                      <v-btn
                        @click="saveContactPerson"
                        style="font-size: 10px; margin-left: auto"
                        elevation="2"
                        tilerounded="5px"
                        small
                        color="primary"
                        class="white--text"
                      >
                        <v-icon small class="mr-2"> mdi-content-save </v-icon>
                        <span>Simpan</span>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div style="padding: 0 10px; margin: 0 0 15px 0">
                        <v-col cols="12" style="padding: 0">
                          <v-data-table
                            :headers="vendorContactPersonHeaders"
                            :items="form.contact_person"
                            hide-default-footer
                            class="elevation-1"
                            dense
                          >
                            <template v-slot:[`item.no`]="{ index }">
                              <div style="width: 25px; font-size: 12px">
                                {{ index + 1 }}
                              </div>
                            </template>
                            <template v-slot:[`item.name`]="{ item }">
                              <div
                                style="
                                  width: 210px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  outlined
                                  readonly
                                  v-model="item.name"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.position`]="{ item }">
                              <div
                                style="
                                  width: 120px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  outlined
                                  readonly
                                  v-model="item.position"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.phone`]="{ item }">
                              <div
                                style="
                                  width: 160px;
                                  height: 45px;
                                  font-size: 10px;
                                "
                              >
                                <v-text-field
                                  @keydown.enter.prevent
                                  dense
                                  outlined
                                  readonly
                                  v-model="item.phone"
                                />
                              </div>
                            </template>
                            <template v-slot:[`item.action`]="{ index }">
                              <div
                                class="d-flex justify-center align-center"
                                style="width: 50px; height: 60px"
                              >
                                <v-tooltip right>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        removeTableItem('contact_person', index)
                                      "
                                      small
                                      color="error"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span>Delete</span>
                                </v-tooltip>
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <div class="d-flex justify-content-between align-center">
              <v-btn
                rounded
                outlined
                elevation="0"
                color="primary"
                type="submit"
                class="white--text font-weight-bold me-5"
                style="font-size: 12px"
                :loading="loading"
              >
                Berikutnya
              </v-btn>
              <v-btn
                type="button"
                rounded
                outlined
                elevation="0"
                color="red"
                @click="clearForm(1)"
                class="white--text font-weight-bold"
                style="font-size: 12px"
                :loading="loading"
              >
                Hapus
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 2" step="2">
          Informasi Pembayaran (Finance)
        </v-stepper-step>
        <v-stepper-content step="2">
          <v-form
            ref="stepTwoForm"
            @submit.prevent="nextStep(2)"
            lazy-validation
            :disabled="loading"
          >
            <v-row no-gutters style="padding: 15px">
              <v-col cols="12" md="4" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nama PIC *
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      @keydown.enter.prevent
                      dense
                      outlined
                      :rules="rules.financeNameRules"
                      v-model="form.finance_pic_name"
                      autocomplete="on"
                    />
                  </v-col>
                </div>
              </v-col>
              <v-col cols="12" md="4" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nomor PIC *
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      @keydown.enter.prevent
                      dense
                      outlined
                      type="number"
                      :rules="rules.financePhoneRules"
                      v-model="form.finance_pic_phone"
                      autocomplete="on"
                    />
                  </v-col>
                </div>
              </v-col>

              <v-col cols="12" md="4" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Atas Nama *
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      @keydown.enter.prevent
                      dense
                      outlined
                      :rules="rules.financeAccountNameRules"
                      v-model="form.finance_account_name"
                      autocomplete="on"
                    />
                  </v-col>
                </div>
              </v-col>
              <v-col cols="12" md="8" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Metode Pembayaran *
                    </p>
                  </v-col>
                  <v-col
                    cols="12"
                    style="
                      padding: 0;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin-bottom: 0;
                    "
                  >
                    <v-radio-group
                      @keydown.enter.prevent
                      :rules="rules.financePaymentMethodRules"
                      v-model="form.finance_payment_method"
                      style="
                        width: 100%;
                        height: 30px;
                        position: relative;
                        top: -10px;
                      "
                    >
                      <div
                        class="d-flex justify-content-between align-content-between"
                      >
                        <div
                          style="
                            padding: 0;
                            justify-content: flex-start;
                            align-items: center;
                            display: flex;
                          "
                        >
                          <v-radio
                            :value="1"
                            style="margin: 0; height: 25px; padding: 0"
                          ></v-radio>
                          <p style="margin: 0; font-size: 12px">Cash</p>
                        </div>
                        <div
                          style="
                            padding: 0;
                            justify-content: flex-start;
                            align-items: center;
                            display: flex;
                          "
                        >
                          <v-radio
                            :value="2"
                            style="margin: 0; height: 25px; padding: 0"
                          ></v-radio>
                          <p style="margin: 0; font-size: 12px">TOP 15</p>
                        </div>
                        <div
                          style="
                            padding: 0;
                            justify-content: flex-start;
                            align-items: center;
                            display: flex;
                          "
                        >
                          <v-radio
                            :value="3"
                            style="margin: 0; height: 25px; padding: 0"
                          ></v-radio>
                          <p style="margin: 0; font-size: 12px">TOP 25</p>
                        </div>
                        <div
                          style="
                            padding: 0;
                            justify-content: flex-start;
                            align-items: center;
                            display: flex;
                          "
                        >
                          <v-radio
                            :value="4"
                            style="margin: 0; height: 25px; padding: 0"
                          ></v-radio>
                          <p style="margin: 0; font-size: 12px">TOP 30</p>
                        </div>
                        <div
                          style="
                            padding: 0;
                            justify-content: flex-start;
                            align-items: center;
                            display: flex;
                          "
                        >
                          <v-radio
                            :value="5"
                            style="margin: 0; height: 25px; padding: 0"
                          ></v-radio>
                          <p style="margin: 0; font-size: 12px">TOP 45</p>
                        </div>
                      </div>
                    </v-radio-group>
                  </v-col>
                </div>
              </v-col>
            </v-row>
            <v-row
              style="
                border: 1px solid rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                padding: 10px;
              "
              no-gutters
            >
              <v-col cols="12" md="5" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nomor Rekening *
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      @keydown.enter.prevent
                      dense
                      outlined
                      type="number"
                      :rules="rules.financeAccountNumberRules"
                      v-model="form.finance_account_number"
                      autocomplete="on"
                    />
                  </v-col>
                </div>
              </v-col>
              <v-col cols="12" md="5" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Bank *
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-autocomplete
                      @keydown.enter.prevent
                      autocomplete="on"
                      v-model="form.finance_bank"
                      :items="dropdown.bank"
                      :rules="rules.financeBankRules"
                      style="margin: 0"
                      item-text="name"
                      item-value="code"
                      return-object
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                </div>
              </v-col>
              <v-col cols="12" md="2" style="padding: 0"></v-col>
              <v-col cols="12" md="5" style="padding: 0">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Kantor Cabang (KCU)
                    </p>
                  </v-col>
                  <v-col cols="12" style="padding: 0">
                    <v-text-field
                      @keydown.enter.prevent
                      dense
                      outlined
                      :rules="rules.financeKcuRules"
                      v-model="form.finance_kcu"
                      autocomplete="on"
                    />
                  </v-col>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="7"
                style="padding: 10px"
                class="d-flex justify-center align-center"
              >
                <v-btn
                  @click="saveVendorFinance"
                  style="font-size: 10px; margin-right: auto"
                  elevation="2"
                  tilerounded="5px"
                  small
                  color="primary"
                  class="white--text"
                >
                  <v-icon small class="mr-2"> mdi-content-save </v-icon>
                  <span>Simpan</span>
                </v-btn>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <div style="padding: 0 10px; margin-top: 15px">
                  <v-col cols="12" style="padding: 0">
                    <v-data-table
                      :headers="financeHeaders"
                      :items="form.finance"
                      hide-default-footer
                      class="elevation-1"
                      dense
                    >
                      <template v-slot:[`item.no`]="{ index }">
                        <div style="width: 25px; font-size: 12px">
                          {{ index + 1 }}
                        </div>
                      </template>
                      <template v-slot:[`item.account_number`]="{ item }">
                        <div
                          style="width: 160px; height: 45px; font-size: 12px"
                        >
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            outlined
                            readonly
                            v-model="item.account_number"
                          />
                        </div>
                      </template>
                      <template v-slot:[`item.bank`]="{ item }">
                        <div
                          style="width: 160px; height: 45px; font-size: 12px"
                        >
                          <v-autocomplete
                            @keydown.enter.prevent
                            v-model="item.bank"
                            :items="dropdown.bank"
                            dense
                            readonly
                            outlined
                            item-text="name"
                            item-value="id"
                            return-object
                            style="margin: 0"
                          ></v-autocomplete>
                        </div>
                      </template>
                      <template v-slot:[`item.kcu`]="{ item }">
                        <div
                          style="width: 160px; height: 45px; font-size: 12px"
                        >
                          <v-text-field
                            @keydown.enter.prevent
                            dense
                            outlined
                            readonly
                            v-model="item.kcu"
                          />
                        </div>
                      </template>
                      <template v-slot:[`item.action`]="{ index }">
                        <div
                          class="d-flex justify-center align-center"
                          style="width: 50px; height: 60px"
                        >
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="removeTableItem('finance', index)"
                                small
                                color="error"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </div>
              </v-col>
            </v-row>

            <div class="d-flex justify-content-between align-center mt-10">
              <div>
                <v-btn
                  type="button"
                  rounded
                  outlined
                  elevation="0"
                  color="red"
                  @click="stepperElement = 1"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Sebelumnya
                </v-btn>
                <v-btn
                  type="submit"
                  rounded
                  outlined
                  elevation="0"
                  color="primary"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Berikutnya
                </v-btn>
              </div>
              <v-btn
                type="button"
                rounded
                outlined
                elevation="0"
                color="red"
                @click="clearForm(2)"
                class="white--text font-weight-bold"
                style="font-size: 12px"
                :loading="loading"
              >
                Hapus
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 3" step="3">
          Kategori Produk/Jasa yang Ditawarkan
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-form
            ref="stepThreeForm"
            @submit.prevent="nextStep(3)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Kategori Produk/ Jasa
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-textarea
                        @keydown.enter.prevent
                        dense
                        outlined
                        rows="3"
                        auto-grow
                        v-model="form.product_category_description"
                        :rules="rules.productCategoryRules"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="10" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Lampirkan Katalog Disini
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-file-input
                        style="font-size: 11px"
                        ref="uploadDoc"
                        placeholder="Pilih file"
                        dense
                        append-icon="mdi-paperclip"
                        prepend-icon=""
                        clearable
                        outlined
                        @click:clear="clearFileKatalog(undefined)"
                        @change="(event) => uploadKatalog(event)"
                      ></v-file-input>
                    </v-col>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                  style="padding: 10px"
                  class="d-flex justify-center align-center"
                >
                  <v-btn
                    @click="saveProductCategory"
                    style="font-size: 10px; margin-left: auto"
                    elevation="2"
                    tilerounded="5px"
                    small
                    color="primary"
                    class="white--text"
                  >
                    <v-icon small class="mr-2"> mdi-content-save </v-icon>
                    <span>Simpan</span>
                  </v-btn>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px; margin-top: 15px">
                    <v-col cols="12" style="padding: 0">
                      <v-data-table
                        :headers="categoryProductHeaders"
                        :items="form.product_category"
                        hide-default-footer
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="width: 25px; font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.description`]="{ item }">
                          <div style="font-size: 12px; padding-top: 10px">
                            <v-textarea
                              @keydown.enter.prevent
                              dense
                              auto-grow
                              :rows="1"
                              outlined
                              readonly
                              v-model="item.description"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.file`]="{ item }">
                          <div style="font-size: 12px; padding-top: 10px">
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              outlined
                              readonly
                              v-model="item.file"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ index }">
                          <div
                            class="d-flex justify-center align-center"
                            style="width: 50px; height: 60px"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="
                                    removeTableItem('product_category', index)
                                  "
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="error"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>

            <div class="d-flex justify-content-between align-center mt-10">
              <div>
                <v-btn
                  type="button"
                  rounded
                  outlined
                  elevation="0"
                  color="red"
                  @click="stepperElement = 2"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Sebelumnya
                </v-btn>
                <v-btn
                  type="submit"
                  rounded
                  outlined
                  elevation="0"
                  color="primary"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Berikutnya
                </v-btn>
              </div>
              <v-btn
                type="button"
                rounded
                outlined
                elevation="0"
                color="red"
                @click="clearForm(3)"
                class="white--text font-weight-bold"
                style="font-size: 12px"
                :loading="loading"
              >
                Hapus
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 4" step="4">
          Pengalaman & Referensi Client
        </v-stepper-step>
        <v-stepper-content step="4">
          <v-form
            ref="stepFourForm"
            @submit.prevent="nextStep(4)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0">
              <v-row style="padding: 15px" no-gutters>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Nama Client
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        :rules="rules.clientNameRules"
                        v-model="form.exp_client_name"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        No. Telepon Client
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        type="number"
                        v-model="form.exp_client_phone"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Proyek / Produk yang disuplai
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        outlined
                        :rules="rules.projectDescRules"
                        v-model="form.exp_project_or_product"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12" md="4" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Tahun
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        @keydown.enter.prevent
                        dense
                        type="number"
                        outlined
                        :rules="rules.projectYearRules"
                        v-model="form.exp_year"
                        autocomplete="on"
                      />
                    </v-col>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                  style="padding: 10px"
                  class="d-flex justify-center align-center"
                >
                  <v-btn
                    @click="saveExperience"
                    style="font-size: 10px; margin-left: auto"
                    elevation="2"
                    tilerounded="5px"
                    small
                    color="primary"
                    class="white--text"
                  >
                    <v-icon small class="mr-2"> mdi-content-save </v-icon>
                    <span>Simpan</span>
                  </v-btn>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <div style="padding: 0 10px; margin-top: 15px">
                    <v-col cols="12" style="padding: 0">
                      <v-data-table
                        :headers="experienceHeaders"
                        :items="form.experience"
                        hide-default-footer
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:[`item.no`]="{ index }">
                          <div style="width: 25px; font-size: 12px">
                            {{ index + 1 }}
                          </div>
                        </template>
                        <template v-slot:[`item.client_name`]="{ item }">
                          <div
                            style="width: 210px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              outlined
                              readonly
                              v-model="item.client_name"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.client_phone`]="{ item }">
                          <div
                            style="width: 210px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              readonly
                              outlined
                              v-model="item.client_phone"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.project_or_product`]="{ item }">
                          <div
                            style="width: 310px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              outlined
                              readonly
                              v-model="item.project_or_product"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.year`]="{ item }">
                          <div
                            style="width: 75px; height: 45px; font-size: 12px"
                          >
                            <v-text-field
                              @keydown.enter.prevent
                              dense
                              outlined
                              type="number"
                              readonly
                              v-model="item.year"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ index }">
                          <div
                            class="d-flex justify-center align-center"
                            style="width: 50px; height: 60px"
                          >
                            <v-tooltip right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="removeTableItem('experience', index)"
                                  v-bind="attrs"
                                  v-on="on"
                                  small
                                  color="error"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-card>

            <div class="d-flex justify-content-between align-center mt-10">
              <div>
                <v-btn
                  type="button"
                  rounded
                  outlined
                  elevation="0"
                  color="red"
                  @click="stepperElement = 3"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Sebelumnya
                </v-btn>
                <v-btn
                  type="submit"
                  rounded
                  outlined
                  elevation="0"
                  color="primary"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Berikutnya
                </v-btn>
              </div>
              <v-btn
                type="button"
                rounded
                outlined
                elevation="0"
                color="red"
                @click="clearForm(4)"
                class="white--text font-weight-bold"
                style="font-size: 12px"
                :loading="loading"
              >
                Hapus
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-step :complete="stepperElement > 5" step="5">
          Kelengkapan Dokumen
          <!-- <small style="margin-top: 5px">(password dapat dilewatkan)</small> -->
        </v-stepper-step>
        <v-stepper-content step="5">
          <v-form
            ref="stepFiveForm"
            @submit.prevent="nextStep(5)"
            lazy-validation
            :disabled="loading"
          >
            <v-card elevation="0" class="mb-12">
              <v-row style="padding: 15px" no-gutters>
                <v-col cols="12" style="padding: 0">
                  <v-data-table
                    :headers="documentHeaders"
                    :items="form.vendor_document"
                    hide-default-footer
                    class="elevation-1"
                    dense
                  >
                    <template v-slot:[`item.no`]="{ index }">
                      <div style="width: 35px; font-size: 12px">
                        {{ index + 1 }}
                      </div>
                    </template>
                    <template v-slot:[`item.document_name`]="{ item }">
                      <div style="width: 280px; height: 45px; font-size: 10px">
                        <v-text-field
                          style="font-size: 11px"
                          @keydown.enter.prevent
                          dense
                          readonly
                          outlined
                          v-model="item.document_name"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.is_have`]="{ item }">
                      <div>
                        <v-checkbox
                          v-model="item.is_have"
                          style="margin: 0; height: 25px; padding: 0"
                        ></v-checkbox>
                      </div>
                    </template>
                    <template v-slot:[`item.file`]="{ item, index }">
                      <div
                        style="width: 160px; height: 45px; position: relative"
                      >
                        <v-file-input
                          style="font-size: 11px"
                          ref="uploadDoc"
                          placeholder="Upload File"
                          dense
                          append-icon="mdi-paperclip"
                          prepend-icon=""
                          clearable
                          @click:clear="clearFileUpload(index)"
                          @change="(event) => uploadFileDoc(index, event)"
                        ></v-file-input>
                        <span
                          style="
                            position: absolute;
                            bottom: 0;
                            font-size: 9px;
                            width: 210px;
                          "
                          >{{ item.file }}</span
                        >
                      </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div style="width: 160px; height: 45px; font-size: 12px">
                        <v-text-field
                          @keydown.enter.prevent
                          dense
                          outlined
                          v-model="item.description"
                        />
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item, index }">
                      <div
                        class="d-flex justify-center align-center"
                        style="width: 50px; height: 60px"
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="error"
                              @click="clearDocument(item, index)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
            <div class="d-flex justify-content-between align-center">
              <div>
                <v-btn
                  type="button"
                  rounded
                  outlined
                  elevation="0"
                  color="red"
                  @click="stepperElement = 4"
                  class="white--text font-weight-bold me-5"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Sebelumnya
                </v-btn>
                <v-btn
                  type="submit"
                  rounded
                  outlined
                  elevation="0"
                  color="success"
                  class="white--text font-weight-bold"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Kirim Formulir
                </v-btn>
              </div>

              <div>
                <v-btn
                  type="button"
                  rounded
                  outlined
                  elevation="0"
                  color="red"
                  @click="clearForm(5)"
                  class="white--text font-weight-bold mr-2"
                  style="font-size: 12px"
                  :loading="loading"
                >
                  Hapus
                </v-btn>
              </div>
            </div>
          </v-form>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
  <!-- </div>
    </div>
    <v-card
      v-else
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      DATA NOT FOUND
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div> -->
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import bankJson from '../../../assets/json/bank.json'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'vendorRegistration',
  components: {},
  data() {
    return {
      config: require('../../../services/config.json')[env],
      hrsApi: buildType.apiURL('hrs'),
      upload: buildType.apiURL('upload2'),
      procApi: buildType.apiURL('proc'),
      eSanqua: buildType.apiURL('esanqua'),
      build: process.env.VUE_APP_BUILD_TYPE,
      dialogForm: false,
      // permission: null,
      // appLevel: null,
      // userLevel: null,
      loading: false,
      // isLoadingPage: true,
      isDisableCompanyDropdown: false,
      form: {
        company_address: null,
        lat: null,
        lng: null,
        post_code: null,
        city: null,
        province: null,
        email: null,
        phone_number: null,
        classification: null,
        sub_classification: null,
        company_scale: null,
        company_type: null,
        company_name: null,
        year_founded: null,
        account_number: null,
        contact_person: [],
        finance: [],
        product_category: [],
        experience: [],
        vendor_document: [],
        vendor_cp_name: null,
        vendor_cp_position: null,
        vendor_cp_phone: null,
        finance_pic_name: null,
        finance_pic_phone: null,
        finance_account_number: null,
        finance_bank: null,
        finance_kcu: null,
        finance_account_name: null,
        finance_payment_method: null,
        product_category_description: null,
        product_category_file: null,
        exp_client_name: null,
        exp_client_phone: null,
        exp_project_or_product: null,
        exp_year: null
      },
      stepperElement: 1,
      wWidth: window.innerWidth,
      rules: {
        companyNameRules: [],
        companyTypeRules: [],
        addressRules: [],
        provinceRules: [],
        postCodeRules: [],
        latRules: [],
        lngRules: [],
        phoneRules: [],
        emailRules: [],
        companyScaleRules: [],
        classificationRules: [],
        subClassificationRules: [],
        financeRules: [],
        productCategoryRules: [],
        experienceRules: [],
        documentRules: [],
        vendorNameRules: [],
        vendorPhoneRules: [],
        financeNameRules: [],
        financePhoneRules: [],
        financeAccountNumberRules: [],
        financeBankRules: [],
        financeKcuRules: [],
        financeAccountNameRules: [],
        clientNameRules: [],
        projectDescRules: [],
        projectYearRules: []
      },
      dropdown: {
        province: [],
        city: [],
        classification: [],
        subClassification: [],
        paymentMethod: [
          { id: 1, name: 'CASH' },
          { id: 2, name: 'TOP 15' },
          { id: 3, name: 'TOP 25' },
          { id: 4, name: 'TOP 30' },
          { id: 5, name: 'TOP 45' }
        ],
        bank: bankJson
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    vendorContactPersonHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama CP',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jabatan',
          value: 'position',
          align: 'left',
          sortable: false
        },
        {
          text: 'No. Telepon',
          value: 'phone',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    financeHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },

        {
          text: 'No. Rekening',
          value: 'account_number',
          align: 'left',
          sortable: false
        },
        {
          text: 'Bank',
          value: 'bank',
          align: 'left',
          sortable: false
        },
        {
          text: 'KCU',
          value: 'kcu',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    categoryProductHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'center',
          sortable: false
        },
        {
          text: 'Katalog File',
          value: 'file',
          align: 'center',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    experienceHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Client Name',
          value: 'client_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Client Phone',
          value: 'client_phone',
          align: 'left',
          sortable: false
        },
        {
          text: 'Proyek/Product',
          value: 'project_or_product',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tahun',
          value: 'year',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    },
    documentHeaders() {
      const arr = [
        {
          text: 'No',
          value: 'no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Dokumen',
          value: 'document_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Ada ?',
          value: 'is_have',
          align: 'left',
          sortable: false
        },
        {
          text: 'File',
          value: 'file',
          align: 'left',
          sortable: false
        },
        {
          text: 'Keterangan',
          value: 'description',
          align: 'center',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arr
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })

    this.appLevel = this.config.application.hr.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.form.company = {
      id: Number(this.getUserProfile.employee.company.plant_id),
      name: this.getUserProfile.employee.company.name
    }
    this.setDocument()
    this.dropdownClassification()
    this.dropdownProvince()
    // console.log('bank>>>', dropdownBank)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)

    for (let i = 0; i < this.form.vendor_document.length; i++) {
      if (this.form.vendor_document[i].file != null) {
        this.clearFileUpload(i)
      }
    }
  },
  watch: {
    'form.company'() {
      if (this.form != null && this.form.company != null) {
        // this.dropdownDepartment()
      }
    },
    'form.classification'() {
      if (this.form != null && this.form.classification != null) {
        if (
          this.form.classification.sub_classification != null &&
          this.form.classification.sub_classification.length > 0
        ) {
          this.dropdown.subClassification =
            this.form.classification.sub_classification
        }
      } else {
        this.dropdown.subClassification = []
        this.form.sub_classification = null
      }
    },
    'form.province'() {
      if (this.form != null && this.form.province != null) {
        if (
          this.form.province.city != null &&
          this.form.province.city.length > 0
        ) {
          this.dropdown.city = this.form.province.city
        }
      } else {
        this.dropdown.city = []
        this.form.city = null
      }
    }
  },
  methods: {
    // ...mapActions(['menu_access', 'getMenuId']),
    setDocument() {
      this.form.vendor_document = [
        {
          document_name: 'Profil Perusahaan',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'Akta Pendirian & Perubahannya',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'NPWP',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'SIUP/TDB/NIB',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'SPPKP (Surat Pengukuhan Pengusaha Kena Pajak)',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'NITKU (Jika transaksi bukan ke pusat)',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'Surat Keterangan Domisili',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'Sertifikat ISO / SBU / Izin Khusus (jika ada)',
          is_have: null,
          file: null,
          description: null
        },
        {
          document_name: 'Surat Pernyataan Bebas Konflik Kepentingan',
          is_have: null,
          file: null,
          description: null
        }
      ]
    },
    async clearDocument(item, index) {
      // console.log('clearDocument')
      if (this.form.vendor_document[index].file != null) {
        this.clearFileUpload(index)
      }
      setTimeout(() => {
        this.form.vendor_document[index].is_have = null
        this.form.vendor_document[index].description = null
      }, 1000)
    },
    clearFileUpload(index) {
      const fileName = this.form.vendor_document[index].file
      if (fileName === null || fileName === '') {
        this.form.vendor_document[index].file = null
      } else {
        // this.form.vendor_document[index].file = null
        const data = {
          module: 'vendor_regist',
          file_name: fileName
        }
        axios
          .post(`${this.upload}esanqua/procurement/unlink`, data)
          .then((res) => {
            // console.log('Unlink>>>>>', res)
            if (res.data.status_code === '00') {
              this.showMsgDialog('success', res.data.status_msg, false)
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
            this.form.vendor_document[index].file = null
          })
          .catch((err) => {
            this.showMsgDialog('error', err.message, false)
            this.form.vendor_document[index].file = null
          })
      }
    },
    uploadFileDoc(index, event) {
      console.log('Index:', index)
      console.log('Event:', event)

      if (event !== null) {
        if (event.size <= 1024 * 1024 * 1) {
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'vendor_regist')
          // data.append('module', 'vendor')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.form.vendor_document[index].file = res.data.data.name
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 1MB', false)
          }, 300)
        }
      }
      setTimeout(() => {
        console.log(this.form.vendor_document[index])
      }, 2000)
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    removeTableItem(pValue, index) {
      if (pValue == 'product_category') {
        this.clearFileKatalog(index)
      }

      this.form[pValue].splice(index, 1)
    },
    saveVendorFinance() {
      const self = this
      // this.rules.financePaymentMethodRules = [
      //   (v) => !!v || 'Payment method is required'
      // ]
      // this.rules.financeNameRules = [
      //   (v) => !!v || 'PIC name is required'
      // ]
      // this.rules.financePhoneRules = [
      //   (v) => !!v || 'PIC phone is required'
      // ]
      this.rules.financeBankRules = [(v) => !!v || 'Bank name is required']
      this.rules.financeAccountNumberRules = [
        (v) => !!v || 'Account number is required'
      ]
      // this.rules.financeKcuRules = [
      //   (v) => !!v || 'KCU is required'
      // ]
      this.rules.financeAccountNameRules = [
        (v) => !!v || 'Account name is required'
      ]
      setTimeout(function () {
        if (self.$refs.stepTwoForm.validate()) {
          self.form.finance.push({
            // name: self.form.finance_pic_name,
            // phone: self.form.finance_pic_phone,
            account_number: self.form.finance_account_number,
            bank: self.form.finance_bank,
            kcu: self.form.finance_kcu
            // account_name: self.form.finance_account_name,
            // payment_method: self.form.finance_payment_method
          })
          setTimeout(() => {
            // self.form.finance_pic_name = null
            // self.form.finance_pic_phone = null
            self.form.finance_account_number = null
            self.form.finance_bank = null
            self.form.finance_kcu = null
            // self.form.finance_account_name = null
            // self.form.finance_payment_method = null
            self.rules.financeBankRules = []
            self.rules.financeAccountNumberRules = []
            self.rules.financeAccountNameRules = []
          }, 100)
        }
      })
    },
    saveContactPerson() {
      const self = this
      this.rules.vendorNameRules = [
        (v) => !!v || 'Contact person name is required'
      ]
      this.rules.vendorPhoneRules = [
        (v) => !!v || 'Contact person phone is required'
      ]
      setTimeout(function () {
        if (self.$refs.stepOneForm.validate()) {
          self.form.contact_person.push({
            name: self.form.vendor_cp_name,
            phone: self.form.vendor_cp_phone,
            position: self.form.vendor_cp_position
          })
          setTimeout(() => {
            self.form.vendor_cp_name = null
            self.form.vendor_cp_phone = null
            self.form.vendor_cp_position = null
            self.rules.vendorNameRules = []
            self.rules.vendorPhoneRules = []
          }, 100)
        }
      })
    },
    saveProductCategory() {
      const self = this
      this.rules.productCategoryRules = [
        (v) => !!v || 'Product category is required'
      ]
      setTimeout(function () {
        if (self.$refs.stepThreeForm.validate()) {
          self.form.product_category.push({
            description: self.form.product_category_description,
            file: self.form.product_category_file
          })
          setTimeout(() => {
            self.form.product_category_description = null
            self.form.product_category_file = null
            self.rules.productCategoryRules = []
          }, 100)
        }
      })
    },
    saveExperience() {
      const self = this
      this.rules.clientNameRules = [(v) => !!v || 'Client name is required']
      this.rules.projectDescRules = [
        (v) => !!v || 'Supplied project & product is required'
      ]
      this.rules.projectYearRules = [(v) => !!v || 'Project year is required']
      setTimeout(function () {
        if (self.$refs.stepFourForm.validate()) {
          self.form.experience.push({
            client_name: self.form.exp_client_name,
            client_phone: self.form.exp_client_phone,
            project_or_product: self.form.exp_project_or_product,
            year: self.form.exp_year
          })
          setTimeout(() => {
            self.form.exp_client_name = null
            self.form.exp_client_phone = null
            self.form.exp_project_or_product = null
            self.form.exp_year = null
            self.rules.clientNameRules = []
            self.rules.projectDescRules = []
            self.rules.projectYearRules = []
          }, 100)
        }
      })
    },
    clearForm(val) {
      if (val === 1) {
        // reset error validation
        // this.$refs.stepOneForm.resetValidation()

        // // reset form
        this.$refs.stepOneForm.reset()
        this.form.contact_person = []
      }
      if (val === 2) {
        // this.$refs.stepTwoForm.resetValidation()
        this.$refs.stepTwoForm.reset()
        this.form.finance = []
      }
      if (val === 3) {
        this.$refs.stepThreeForm.reset()
        this.form.product_category = []
      }
      if (val === 4) {
        this.$refs.stepFourForm.reset()
        this.form.experience = []
      }
      if (val === 5) {
        if (
          this.form.vendor_document != null &&
          this.form.vendor_document.length > 0
        ) {
          for (let i = 0; i < this.form.vendor_document.length; i++) {
            if (this.form.vendor_document[i].file != null) {
              this.clearFileUpload(i)
            }
            this.form.vendor_document[i].is_have = null
            this.form.vendor_document[i].description = null
          }
        }
        this.$refs.stepFiveForm.reset()
        setTimeout(() => {
          this.setDocument()
        }, 300)
      }
    },
    // cancelForm() {
    //   if (
    //     this.form.vendor_document != null &&
    //     this.form.vendor_document.length > 0
    //   ) {
    //     for (let i = 0; i < this.form.vendor_document.length; i++) {
    //       if (this.form.vendor_document[i].file != null) {
    //         this.clearFileUpload(i)
    //       }
    //       this.form.vendor_document[i].is_have = null
    //       this.form.vendor_document[i].description = null
    //     }
    //   }
    //   this.form.contact_person = []
    //   this.form.finance = []
    //   this.form.experience = []
    //   this.form.product_category = []
    //   setTimeout(() => {
    //     this.$refs.stepOneForm.reset()
    //     this.$refs.stepTwoForm.reset()
    //     this.$refs.stepThreeForm.reset()
    //     this.$refs.stepFourForm.reset()
    //     this.$refs.stepFiveForm.reset()
    //     this.stepperElement = 1
    //   }, 300)
    // },
    nextStep(val) {
      const self = this
      if (val === 1) {
        this.rules.companyNameRules = [(v) => !!v || 'Company name is required']
        this.rules.companyTypeRules = [(v) => !!v || 'Company type is required']
        this.rules.addressRules = [(v) => !!v || 'Address is required']
        this.rules.provinceRules = [(v) => !!v || 'Province is required']
        this.rules.cityRules = [(v) => !!v || 'City is required']
        // // this.rules.postCodeRules = [(v) => !!v || 'Post code is required']
        this.rules.addressRules = [(v) => !!v || 'Address is required']
        // // this.rules.latRules = [(v) => !!v || 'Lat is required']
        // // this.rules.lngRules = [(v) => !!v || 'Lng is required']
        this.rules.phoneRules = [(v) => !!v || 'Company phone is required']
        this.rules.emailRules = [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ]
        // // this.rules.websiteRules = [(v) => !!v || 'Website is required']
        this.rules.companyScaleRules = [
          (v) => !!v || 'Company scale is required'
        ]
        this.rules.classificationRules = [
          (v) => !!v || 'Classification is required'
        ]
        // // this.rules.subClassificationRules = [(v) => !!v || 'Company scale is required']
        this.rules.vendorNameRules = []
        this.rules.vendorPhoneRules = []
        if (this.form.contact_person.length < 1) {
          return this.showMsgDialog(
            'warning',
            'Contact person wajib diisi minimal 1',
            false
          )
        }
        setTimeout(function () {
          if (self.$refs.stepOneForm.validate()) {
            self.stepperElement = 2
          }
        })
      }

      if (val === 2) {
        if (this.form.finance.length < 1) {
          return this.showMsgDialog(
            'warning',
            'Data finance wajib diisi minimal 1',
            false
          )
        }
        setTimeout(function () {
          if (self.$refs.stepTwoForm.validate()) {
            self.stepperElement = 3
          }
        })
      }

      if (val === 3) {
        // if (this.form.product_category.length < 1) {
        //   return this.showMsgDialog(
        //     'warning',
        //     'Kategori produk dan jasa yang ditawarkan wajib diisi minimal 1',
        //     false
        //   )
        // }
        setTimeout(function () {
          // if (self.$refs.stepThreeForm.validate()) {
          self.stepperElement = 4
          // }
        })
      }
      if (val === 4) {
        // if (this.form.experience.length < 1) {
        //   return this.showMsgDialog(
        //     'warning',
        //     'Pengalaman & referensi client wajib diisi minimal 1',
        //     false
        //   )
        // }
        setTimeout(function () {
          // if (self.$refs.stepFourForm.validate()) {
          self.stepperElement = 5
          // }
        })
      }
      if (val === 5) {
        console.log('Submit Form>>>', this.form)
        // if (this.permission.create_perm == 1) {
        this.createNewForm()
        // }
      }
    },
    createNewForm() {
      let province = null
      let city = null
      let classification = null
      let subClassification = null
      if (this.form.province != null) {
        province = {
          id: this.form.province.id,
          name: this.form.province.name
        }
      }
      if (this.form.city != null) {
        city = {
          id: this.form.city.id,
          name: this.form.city.name
        }
      }
      if (this.form.classification != null) {
        classification = {
          id: this.form.classification.id,
          name: this.form.classification.name
        }
      }
      if (this.form.sub_classification != null) {
        subClassification = {
          id: this.form.sub_classification.id,
          name: this.form.sub_classification.name
        }
      }
      const newForm = {
        act: 'add',
        name: this.form.company_name,
        business_entity: this.form.company_type,
        company_scale: this.form.company_scale,
        lat: this.form.lat,
        lng: this.form.lng,
        post_code: this.form.post_code,
        city_id: city != null ? city.id : null,
        city_name: city != null ? city.name : null,
        province_id: province != null ? province.id : null,
        province_name: province != null ? province.name : null,
        address: this.form.company_address,
        email: this.form.email,
        year_founded: this.form.year_founded,
        phone_number: this.form.phone_number,
        website: this.form.website,
        classification_id: classification != null ? classification.id : null,
        classification_name:
          classification != null ? classification.name : null,
        sub_classification_id:
          subClassification != null ? subClassification.id : null,
        sub_classification_name:
          subClassification != null ? subClassification.name : null,
        vendor_contact:
          this.form.contact_person.length > 0 ? this.form.contact_person : null,
        vendor_finance: {
          account: this.form.finance.length > 0 ? this.form.finance : null,
          pic_name: this.form.finance_pic_name,
          pic_phone: this.form.finance_pic_phone,
          payment_method: this.form.finance_payment_method,
          account_name: this.form.finance_account_name
        },
        vendor_experience:
          this.form.experience.length > 0 ? this.form.experience : null,
        vendor_product_category:
          this.form.product_category.length > 0
            ? this.form.product_category
            : null,
        vendor_document:
          this.form.vendor_document.length > 0
            ? this.form.vendor_document
            : null
      }
      console.log('save>>>', newForm)
      this.save(newForm)
    },
    async save(form) {
      this.loading = true
      await axios
        .post(`${this.procApi}vendor/registration/save`, form)
        .then((res) => {
          console.log(res.data)
          this.loading = false
          if (res.data.status_code == '00') {
            this.resetForm()
            this.showMsgDialog('success', res.data.status_msg, false)
            setTimeout(() => {
              this.$router.push(
                `/e-catalogue/vendor-registration/detail/${res.data.created_id}`
              )
            }, 500)
          } else {
            if (res.data.status_msg == 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    xFlag = true
                  }
                } else {
                  xFlag = true
                }
              } else {
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    closeForm() {
      for (let i = 0; i < this.form.vendor_document.length; i++) {
        if (this.form.vendor_document[i].file != null) {
          this.clearFileUpload(i)
        }
      }
      setTimeout(() => {
        this.resetForm()
        setTimeout(() => {
          this.$router.push('/e-catalogue/vendor-registration')
          // this.dialogForm = false
        }, 100)
      }, 100)
    },
    resetForm() {
      this.$refs.stepOneForm.reset()
      this.$refs.stepTwoForm.reset()
      this.$refs.stepThreeForm.reset()
      this.$refs.stepFourForm.reset()
      this.$refs.stepFiveForm.reset()
    },
    async dropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async dropdownClassification() {
      await axios
        .get(
          `${this.procApi}master/classification/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.classification = res.data.data)
          }
          return (this.dropdown.classification = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.classification = [])
        })
    },
    async dropdownProvince() {
      await axios
        .get(
          `${this.procApi}master/province/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.province = res.data.data)
          }
          return (this.dropdown.province = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.province = [])
        })
    },
    async dropdownCity() {
      await axios
        .get(
          `${this.procApi}master/city/drop_down?order_by=name&order_type=asc&keyword=`
        )
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.city = res.data.data)
          }
          return (this.dropdown.city = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.city = [])
        })
    },

    async clearFileKatalog(index, method) {
      let fileName = null
      if (index == undefined) {
        fileName = this.form.product_category_file
        console.log('Ga ada data yang dipassing')
      } else {
        fileName = this.form.product_category[index].file
      }
      // this.form.vendor_document[index].file = null
      const data = {
        module: 'vendor_regist',
        file_name: fileName
      }
      const unlink = await axios
        .post(`${this.upload}esanqua/procurement/unlink`, data)
        .then((res) => {
          // console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            return '00'
          } else {
            if (method == undefined) {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
          if (index != undefined) {
            this.form.product_category[index].file = null
          }
          return '-99'
        })
        .catch((err) => {
          if (method == undefined) {
            this.showMsgDialog('error', err.message, false)
            if (index != undefined) {
              this.form.product_category[index].file = null
            }
          }
          return '-99'
        })
      return unlink
    },
    async uploadKatalog(event) {
      // const xFlag = false
      console.log('Event:', event)
      // if (xFlag) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 1) {
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'vendor_regist')
          // data.append('module', 'vendor')
          axios
            .post(`${this.upload}esanqua/procurement`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.form.product_category_file = res.data.data.name
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 1MB', false)
          }, 300)
        }
      }
    }
  }
}
</script>
